import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'
import screencheck from "./screencheck";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);



$(document).ready(function () {  
    const multiStep = $(".multiple-steps");
    const stepInfo = multiStep.find(".step-info");
    const step = stepInfo.find(".step");
    const stepLength = step.length;
    const progressBar = multiStep.find(".progress-bar");
    const nextStepButton = $(".button.next-step");
    const stepFormWrapper = $(".step-form-wrapper");
    let currentStep, currentStepChild, currentForm, currentFormInput, currentFormInputLength,inputLength, currentStepIndex, nextStep,prevStep ,currentStepNumber;
    
    function initElem() { 
        currentStep = multiStep.find(".current-step");
        currentStepChild = currentStep.find(".step");
        currentForm = $(".step-form.current");
        currentFormInput = currentForm.find(".textbox, .privacy-checkbox, .custom-drop");
        currentFormInputLength = currentFormInput.length;
        currentStepIndex = currentStep.index();
        nextStep = step.eq(currentStepIndex+1);
        prevStep = (currentStepIndex-1) < 0  ? "" : step.eq(currentStepIndex-1),
        currentStepNumber = currentStep.attr("data-step");
        currentStepNumber = parseInt(currentStepNumber);
        inputLength = stepFormWrapper.find(".textbox ,  .privacy-checkbox, .custom-drop").length;
    }initElem();

    

    let filledInput = currentForm.find(".textbox.filled").length;
    let prevProgress = 0,progress;
    

    function updateProgress() {
        let first_Step_Left_Offset = step.eq(0).length ? step.eq(0)[0].offsetLeft : 0;
        let last_Step_Left_Offset = step.eq(-1).length ? step.eq(-1)[0].offsetLeft : 0;
        let progressWidth = last_Step_Left_Offset - first_Step_Left_Offset;
        let nextStepLeftOffset = nextStep.length ? nextStep[0].offsetLeft-first_Step_Left_Offset : 0;
        let prevStepLeftOffset = prevStep === "" ? 0 :  prevStep.length ? prevStep[0].offsetLeft-first_Step_Left_Offset : 0; 
        let currentLeftOffset = currentStepChild.length ? currentStepChild[0].offsetLeft-first_Step_Left_Offset : 0; 
            
            if(!screencheck(768)){
                progress = prevProgress + (((nextStepLeftOffset - currentLeftOffset ) / currentFormInputLength) * filledInput) / (progressWidth / 100);
            }else{
                progress = prevProgress +  (100 / inputLength) * filledInput;
            }
            progress = Math.round(progress);
            
        if(!screencheck(768)){

            progressBar.css({
                "left" : first_Step_Left_Offset,
                "width": progressWidth,
                "--progress": progress+"%",
            })
            if($(".pagination").length){
                $(".pagination").remove()
            }

        }else{
            if(!$(".pagination").length){
                multiStep.append(`<div class="pagination"><span>${currentStepNumber}</span>/<span>${stepLength-1}</span></div>`)
            }

            progressBar.css({
                "left" : "",
                "width" : "",
                "--progress": progress+"%",
            })
            
            
        }        
    }
    
    function handleInput() {
        let prevInput;
        currentFormInput.on("keyup",function () {
            if($(this).val().length && !$(this).hasClass("filled")){
                if (!$(this).hasClass("hasValue")) {
                    $(this).addClass("hasValue")
                    prevInput = $(this);
                    filledInput+=1;
                    updateProgress()
                }   
            }else{
                if($(this).hasClass("filled")){
                    if (!$(this).hasClass("hasValue")) {
                        $(this).addClass("hasValue")
                        prevInput = $(this);
                        filledInput+=1;
                        updateProgress()
                    }
                }
                if($(this).hasClass("hasValue")){
                    if($(this).val().length <= 0){
                        $(this).removeClass("hasValue")
                        filledInput-=1;
                        updateProgress();
                    }
                }
            }
        })

        currentForm.find(".privacy-checkbox").on("change",function () {
            if($(this).is(":checked")){
                filledInput+=1;
                updateProgress()
            }else{
                filledInput-=1;
                updateProgress()
            }
        })
    }handleInput();

    $(document).on('datepickerSelected', function(e,elem) {
        if(!$(elem).hasClass("filled")){
            filledInput+=1;
            updateProgress()
        }
    })
    let isSelected = false;
    $(document).on("select2selected",function (e,elem) {  
        if($(elem.target).parents(".custom-select-2").hasClass("selected-opt") && !isSelected){
            filledInput+=1;
            updateProgress()
            isSelected = true;
        }else if(!$(elem.target).parents(".custom-select-2").hasClass("selected-opt") && isSelected) {
            filledInput-=1;
            updateProgress()
            isSelected = false;
        }
    })

    let onceTrigger = true;
    function handleXhrStart(event) {
        if($(".codedropz-upload-wrapper .dnd-upload-status.complete").length){
            setTimeout(() => {
                if(onceTrigger){
                    filledInput+=1;
                    updateProgress()
                    onceTrigger = false;
                }
            }, 100);
        }else{
            if(!onceTrigger){
                filledInput-=1;
                updateProgress();
                onceTrigger= true;
            }
        }
    }

    (function () {
        var originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            this.addEventListener('loadend', handleXhrStart);
            return originalOpen.apply(this, arguments);
        };
    })();

     // Function to validate the form fields for the current step
     function validateForm() {
        var isValid = true;
        let currentStepNumber = currentStep.attr("data-step");

  
        // Reset previous error messages
        $('.wpcf7-not-valid-tip').remove();
        $(".wpcf7-not-valid").removeClass("wpcf7-not-valid")
  
        // Check required fields in the current step
        $('.step-form[data-step="' + currentStepNumber + '"] .wpcf7-form-control[aria-required="true"]').each(function () {
          if ($.trim($(this).val()) === '') {
            isValid = false;
            $(this).addClass("wpcf7-not-valid");
            $(this).after('<span class="wpcf7-not-valid-tip">This field is required</span>');
          }
        }); 
  
        return isValid;
      }

    const pause = () => new Promise(resolve =>{
        document.addEventListener("wpcf7mailsent",resolve)
    });

    nextStepButton.on("click", async function () {
        if (!validateForm()) {
            return;
        }
     
        if($(this).is("[type='submit']")){
            await pause();
        }

        let stepTovalue = $(this).data("step-to");
        let stepTo = $(`.step-form[data-step="${stepTovalue}"]`); 
            prevProgress = progress


        gsap.fromTo(currentForm,{
            opacity: 1,
            x: 0,
        },{
            opacity: 0,
            x: "-30px",
            duration: 0.25,
            onComplete: ()=>{
                currentStep.removeClass("current-step")
                nextStep.parent(".step-info").addClass("current-step");
                nextStep.parent(".step-info").prev(".step-info").addClass("complate")
                currentForm.removeClass("current")
                stepTo.addClass("current")
                currentForm = stepTo;
                gsap.to(window, { 
                    duration: 0.5,
                    scrollTo: { y: ".contact-section.job-sponsoring" ,offsetY: screencheck(992) ? 100 : 150},
                    ease: "power2", 
                });
                
                
                gsap.fromTo(stepTo,{
                    opacity: 0, 
                    x: "30px",
                },{
                    opacity: 1,
                    x: 0,
                    duration: 0.25,
                    onComplete: ()=>{
                        filledInput = currentForm.find(".textbox.filled").length;
                        initElem()
                        handleInput()
                        if(screencheck(768)){
                            $(".pagination span").eq(0).text(currentStepNumber).eq(1).text(stepLength-1)
                            if(currentStepNumber > stepLength-1){
                                $(".pagination").addClass("complate")
                            }
                        }

                    }
                }); 
            }
        });
        if(!$(this).is("[type='submit']")){
            return false;
        }
    }) 

    $(window).on("resize",updateProgress).resize()

  

})